import { render } from "./BatchClassForm.vue?vue&type=template&id=1e9c8fc4&ts=true"
import script from "./BatchClassForm.vue?vue&type=script&lang=ts"
export * from "./BatchClassForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__